import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeRepairItemUpdate } from './serialize';

/**
 * PATCH `/aftersales/repair-item/{id}`：僅 remark＋updatedAt。
 * 已被簽收鎖定的品項不可改；無 create／delete。
 *
 * @param {string} id
 * @param {object} payload
 */
export async function updateRepairItem(id, payload) {
  const { data: raw } = await request.patch(
    `/aftersales/repair-item/${id}`,
    serializeRepairItemUpdate(payload),
  );
  return parseVer4DetailResponse(raw);
}
